import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTerminationReason, deleteTerminationReason, getAllTerminationReason, updateTerminationReason } from '../../redux/rtk/features/masters/terminationReasonSlice';
import PageTitle from '../page-header/PageHeader';

const TerminationReasonMaster = () => {
  const { Title } = Typography;
  const [editingTerminationReason, setEditingTerminationReason] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { termination, loading } = useSelector((state) => state.terminationReason);

  useEffect(() => {
    dispatch(getAllTerminationReason());
  }, [dispatch]);



  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingTerminationReason) {
        // Update existing terminationReason
        const result = await dispatch(
          updateTerminationReason({ id: editingTerminationReason.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllTerminationReason());
        } else {
          message.error('Error updating terminationReason!');
        }
      } else {
        // Add new terminationReason
        const result = await dispatch(addTerminationReason(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllTerminationReason());
        } else {
          message.error('Error adding terminationReason!');
        }
      }
      setEditingTerminationReason(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update terminationReason!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteTerminationReason(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllTerminationReason()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Termination Reason',
      dataIndex: 'terminationReason',
      key: 'terminationReason',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingTerminationReason(record); form.setFieldsValue(record);}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this termination reason?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingTerminationReason ? 'Edit Termination Reason' : 'Add Termination Reason'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="category-form"
              labelCol={{ span: 14 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
          <Form.Item
            name="terminationReason"
            label="Termination Reason"
            rules={[{ required: true, message: 'Please enter a termination reason!' }]}
          >
            <Input placeholder="Enter termination reason " />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingTerminationReason ? 'Update Termination Reason' : 'Add Termination Reason'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Termination Reason List">
            <Table
              dataSource={termination}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TerminationReasonMaster;
